import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddAdvisorNotificationEmailDto, OneWayInService } from 'src/api/v2';
import {
  ONE_WAY_IN_ALL_SAVED_FORMS_KEY,
  ONE_WAY_IN_GROUPED_FORM,
  ONE_WAY_IN_OPPORTUNITY_BY_ID,
} from 'src/constants/hook-keys';

const useAddAdvisor = (formId: string) => {
  const [service] = useState(() => new OneWayInService());

  const queryClient = useQueryClient();

  const addAdvisorMutation = useMutation({
    mutationFn: async ({
      opportunityId,
      clusterUserId,
      emailDto,
    }: {
      opportunityId: string;
      clusterUserId: string;
      emailDto: AddAdvisorNotificationEmailDto | undefined;
    }) => service.addAdvisor(opportunityId, clusterUserId, emailDto),
    onSuccess: () => {
      queryClient.invalidateQueries([ONE_WAY_IN_OPPORTUNITY_BY_ID, formId]);
      queryClient.invalidateQueries([ONE_WAY_IN_GROUPED_FORM, formId]);
      queryClient.invalidateQueries([ONE_WAY_IN_ALL_SAVED_FORMS_KEY]);
    },
  });

  return { addAdvisorMutation };
};

export default useAddAdvisor;
